module.exports = __webpack_public_path__ + "img/夢莎逆時雙效賦活面膜Ⅱ.fdba7f03.png";